export default __webpack_public_path__ + "static/media/vincennesmini.dc25a2f9.jpg";